import Vue from 'vue'; 
import Router from 'vue-router'; 
import AdminTop from './views/AdminTop.vue'; 
import SubAdminTop from './views/SubAdminTop.vue';
import CreateUser from './views/CreateUser.vue';
import EditUser from './views/EditUser.vue';
import Login from './views/Login.vue'; 

Vue.use(Router); 

export default new Router({ 
    mode: 'history',
    routes: [ 
        { 
            path: '/', 
            name: 'login', 
            component: Login
        }, 
        {
            path: '/admintop',
            name: 'admintop',
            component: AdminTop
        },
        { 
            path: '/subadmintop', 
            name: 'subadmintop', 
            component: SubAdminTop 
        },
        { 
            path: '/createuser', 
            name: 'createuser', 
            component: CreateUser 
        },
        {
            path: '/edituser/:id', 
            name: 'edituser', 
            component: EditUser 
        }
    ] 
});
